import React from 'react';

export interface CardProps extends React.HTMLAttributes<HTMLDivElement> {
  variant?: 'default' | 'glass' | 'elevated' | 'outlined';
  hover?: boolean;
  children: React.ReactNode;
}

const Card: React.FC<CardProps> = ({
  variant = 'default',
  hover = false,
  children,
  className = '',
  ...props
}) => {
  const baseClasses = 'rounded-2xl transition-all transition-normal ease-smooth';
  
  const variantClasses = {
    default: 'glass-card shadow-glass',
    glass: 'glass-card-strong shadow-glass-strong',
    elevated: 'glass-card shadow-xl',
    outlined: 'glass border border-white/20 shadow-sm'
  };

  const hoverClasses = hover 
    ? 'hover:shadow-glass-strong hover:scale-[1.02] cursor-pointer' 
    : '';

  const classes = `${baseClasses} ${variantClasses[variant]} ${hoverClasses} ${className}`;

  return (
    <div className={classes} {...props}>
      {children}
    </div>
  );
};

export default Card;




